<span class="switch switch-lg">
    <input type="checkbox" class="switch" [(ngModel)]="value" [name]="name" id="switch-{{name}}" [disabled]="disabled" (change)="onCheckboxChange($event)">
    <label for="switch-{{name}}" [i18n]="[{target: 'innerHTML', key: labelKey}]"></label>
</span>
